import * as XLSX from 'xlsx-js-style';

export const FETCH_CHUNK = 100;

export const REPORT_TABLE_HEADER_BG = '#d1fae5';
export const REPORT_TABLE_HEADER_TEXT = '#065f46';
export const REPORT_TABLE_HEADER_BORDER = '#34d399';
export const REPORT_TABLE_HEADER_FILL_RGB = 'D1FAE5';
export const REPORT_TABLE_HEADER_TEXT_RGB = '065F46';
export const REPORT_TABLE_HEADER_BORDER_RGB = '34D399';

export function applyExcelHeaderRowStyle(ws) {
  if (!ws || !ws['!ref']) return;
  const range = XLSX.utils.decode_range(ws['!ref']);
  const r0 = range.s.r;
  for (let c = range.s.c; c <= range.e.c; c += 1) {
    const addr = XLSX.utils.encode_cell({ r: r0, c });
    const cell = ws[addr];
    if (!cell) continue;
    cell.s = {
      font: { bold: true, color: { rgb: REPORT_TABLE_HEADER_TEXT_RGB } },
      fill: { patternType: 'solid', fgColor: { rgb: REPORT_TABLE_HEADER_FILL_RGB } },
      alignment: { vertical: 'center', horizontal: 'center', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
        bottom: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
        left: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
        right: { style: 'thin', color: { rgb: REPORT_TABLE_HEADER_BORDER_RGB } },
      },
    };
  }
}

/**
 * Opens print dialog in the same tab using a hidden iframe (no new browser tab).
 * HTML must not call window.print() itself.
 */
export function printHtmlInSameTab(htmlDocumentString, iframeTitle = 'Print') {
  return new Promise((resolve, reject) => {
    let iframe;
    const removeIframe = () => {
      try {
        if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      } catch {
        /* ignore */
      }
    };

    try {
      iframe = document.createElement('iframe');
      iframe.setAttribute('title', iframeTitle);
      Object.assign(iframe.style, {
        position: 'fixed',
        right: '0',
        bottom: '0',
        width: '0',
        height: '0',
        border: '0',
        visibility: 'hidden',
      });
      document.body.appendChild(iframe);
      const win = iframe.contentWindow;
      if (!win) {
        removeIframe();
        reject(new Error('Print frame not available'));
        return;
      }
      const doc = win.document;
      doc.open();
      doc.write(htmlDocumentString);
      doc.close();

      setTimeout(() => {
        try {
          win.focus();
          win.print();
        } catch (e) {
          removeIframe();
          reject(e);
          return;
        }
        setTimeout(() => {
          removeIframe();
          resolve();
        }, 400);
      }, 200);
    } catch (e) {
      removeIframe();
      reject(e);
    }
  });
}
